// extracted by mini-css-extract-plugin
export default {"paper":"CapturePrimaryLanguage_paper__dNeK+"};